/** Native inline path: PDF up to 30 MB */
export const SCOUT_NATIVE_MAX_PDF_BYTES = 30 * 1024 * 1024;

/** Large-PDF extraction path: PDF up to 200 MB */
export const SCOUT_LARGE_PDF_MAX_BYTES = 200 * 1024 * 1024;

/** Native inline path: PDF up to 50 pages (longer PDFs exceed model context when sent inline). */
export const SCOUT_NATIVE_MAX_PDF_PAGES = 50;

/** Native inline path: images up to 5 MB */
export const SCOUT_NATIVE_MAX_IMAGE_BYTES = 5 * 1024 * 1024;

/** Native inline path: plain text up to 200 KB */
export const SCOUT_NATIVE_MAX_TEXT_BYTES = 200 * 1024;

/** Native inline path: encamp-ai text formats (docx, xlsx, etc.) up to 5 MB */
export const SCOUT_NATIVE_TEXT_SYNC_THRESHOLD_BYTES = 5 * 1024 * 1024;

/** LARGE_FILE_EXTRACTION path: DOCX/XLSX/PPTX/XML up to 50 MB */
export const SCOUT_TEXT_EXTRACTION_OFFICE_MAX_BYTES = 50 * 1024 * 1024;

/** LARGE_FILE_EXTRACTION path: CSV/TSV up to 10 MB */
export const SCOUT_TEXT_EXTRACTION_CSV_MAX_BYTES = 10 * 1024 * 1024;

/** Maximum files attachable to a single Scout message. */
export const SCOUT_MAX_ATTACHMENTS = 5;
